import { splitExpiry } from 'features/payment/utils';

import { CartPaymentCardType } from 'generated/graphql-gateway';
import { ICommitOrderMutationInput, ICommitOrderOptions } from 'hooks/commit-order/types';
import { getConfigValue } from 'utils/environment';

export const buildCommitOrderInput = ({
  applePayDetails,
  billingAddress,
  cashAppInput,
  ccBin,
  ccExpiry,
  ccLast4,
  creditType,
  fdAccessToken,
  fdAccountId,
  fdNonce,
  fireOrderIn,
  fullName,
  pickupTime,
  googlePayDetails,
  payment,
  paypalDetails,
  venmoDetails,
  rbiOrderId,
  distanceToStore,
  checkoutData,
  vehicleDescription,
  pushNotification,
}: ICommitOrderOptions): ICommitOrderMutationInput => {
  const input: ICommitOrderMutationInput = {
    applePayDetails,
    billingAddress,
    cashAppInput,
    creditType,
    fireOrderIn,
    fullName,
    pickupTime,
    payment,
    googlePayDetails,
    rbiOrderId,
    paypalDetails,
    venmoDetails,
    distanceToStore,
    checkoutData,
    vehicleDescription,
    pushNotification,
  };

  if (fdAccountId) {
    input.fdAccountId = fdAccountId;
  } else if (fdAccessToken) {
    input.fdNonce = fdNonce;
    input.fdAccessToken = fdAccessToken;
    input.ccBin = ccBin;
    input.ccLast4 = ccLast4;
  }

  if (ccExpiry) {
    const { expiryMonth, expiryYear } = splitExpiry(ccExpiry);
    input.ccExpiryMonth = expiryMonth;
    input.ccExpiryYear = expiryYear;
    if (input.payment && input.payment.ccMetadata) {
      input.payment.ccMetadata.ccExpiryMonth = expiryMonth;
      input.payment.ccMetadata.ccExpiryYear = expiryYear;
    }
  }

  // This is a dev-only feature to test error handling when committing an order
  // use REACT_APP_FORCE_COMMIT_ORDER_FAILURE=true to test
  if (__DEV__) {
    const shouldCommitOrderFail = getConfigValue({
      key: 'forceCommitOrderFailure',
      defaultValue: false,
    });
    if (shouldCommitOrderFail) {
      input.creditType = 'Invalid' as CartPaymentCardType | null | undefined;
    }
  }

  return input;
};
